import { AppRoute, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class VideoNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  constructor() {
    super('VIDEOS', _('menu.label.videos'), AppRoute.Videos, _('a11y.link.videos'), 'LINKS');
  }
}
